<!-- updated dashboard.component.html -->
<div class="dashboard-container  unselectable">
  <!-- Header -->
 
  <div class="dashboardheader unselectable">
      <h1><b>Demo Dashboard</b></h1>
       <div class="refresh-info">Data last refreshed: {{refreshDate}}</div>
       <div class="header-actions">
       <mat-checkbox [(ngModel)]="isSmallPractice"  (change)="onSmallPracticeChange()" class="small-practice-checkbox" >
          Small Practice
        </mat-checkbox>
      <button mat-raised-button color="primary" class="export-btn" (click)="onExport()">
          <mat-icon>cloud_download</mat-icon> EXPORT
        </button>
        </div>
    </div>

  <!-- Tabs -->
  <mat-tab-group mat-align-tabs="start" (selectedTabChange)="selectTab($event.tab.textLabel.toLowerCase())">
    <mat-tab label="All Measures"></mat-tab>
    <mat-tab label="MIPS Measures"></mat-tab>
    <mat-tab label="MVP Measures"></mat-tab>
  </mat-tab-group>

  <ng-container *ngIf="selectedTab === 'mips measures'">
    <div class="guage-container">
      <app-mips-gauges [gauges]="gauges"></app-mips-gauges>
    </div>
   
  </ng-container>


  <!-- Filters -->
  <div class="filters-container unselectable">
    <div class="filters">
      <mat-form-field appearance="outline">
        <mat-label>Measure Selection</mat-label>
        <mat-select multiple [(ngModel)]="filters.measureSelection">
          <mat-option 
          (click)="toggleAllSelection()" 
          [value]="'all'" 
          [class.selected]="allSelected">
          All
        </mat-option>
          <mat-option  (click)="itemClicked()"  *ngFor="let measure of uniqueMeasures; let i = index" [value]="measure.id">{{measure.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Provider</mat-label>
        <mat-select [(ngModel)]="filters.clinician">
          <mat-option 
          (click)="toggleAllProviders()" 
          [value]="'all'" 
          [class.selected]="allProvidersSelected">
          All
        </mat-option>
          <mat-option  *ngFor="let provider of providers; let i = index" [value]="provider.id">{{provider.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Location</mat-label>
        <mat-select [(ngModel)]="filters.location">
          <mat-option value="option1">Option 1</mat-option>
          <mat-option value="option2">Option 2</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Select Group</mat-label>
        <mat-select [(ngModel)]="filters.selectGroup">
          <mat-option value="option1">Option 1</mat-option>
          <mat-option value="option2">Option 2</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Measure Year</mat-label>
        <mat-select [(ngModel)]="filters.measureYear">
          <mat-option  *ngFor="let year of years; let i = index" [value]="year">{{year}}</mat-option>
        
        </mat-select>
      </mat-form-field>

      <button mat-raised-button color="accent" (click)="applyFilters()" class="apply-filters-btn">Apply Filters</button>
    </div>
  </div>

  <!-- Main Content -->
  <div class="dashboard-content">
    <div class="section-header unselectable">
      <h2>Measure Performance</h2>
      <div class="benchmark-toggle">
        <mat-slide-toggle [(ngModel)]="showBenchmarks" >
          Show National and Registry Benchmarks
        </mat-slide-toggle>
        <div class="benchmark-legend">
          <div class="legend-item">
            <div class="legend-marker national"></div>
            <span>National Benchmark</span>
          </div>
          <div class="legend-item">
            <div class="legend-marker registry"></div>
            <span>Registry Benchmark</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Performance Charts with inline details -->
    <div class="performance-charts unselectable" *ngIf="!showPatientDetails">
      <ng-container *ngFor="let measure of filteredMeasures; let i = index">
        <!-- Measure Row -->
        <div class="measure-row" (click)="onMeasureClick(measure, i)" 
             [class.selected-row]="selectedMeasure.id === measure.id">
          <div class="measure-id" [title]="measure.measureName">{{measure.name}}
            <span *ngIf="measure.isMIPS" class="mips-indicator">M</span>
              <span *ngIf="isInverseMeasure(measure)" class="inverse-indicator" title="Inverse measure (lower is better)">↓</span>
    <span *ngIf="hasSmallDenominator(measure)" class="small-sample-indicator" title="Small sample size (denominator < 20)">*</span>
 </div>
          
          <div class="chart-container">
            <div class="performance-bar" [style.width.%]="measure.value * 100" [style.background-color]="getColor(measure.name??'',measure.value, measure.benchmark?.registry ?? 0, this.isInverseMeasure(measure))">
              <span class="performance-value" *ngIf="measure.value >= .05">{{(measure.value * 100) | number:'1.0-2'}}%</span>
              <span class="performance-value outside" *ngIf="measure.value < .05">{{(measure.value * 100) | number:'1.0-2'}}%</span>
           
            </div>

            
            <!-- Benchmarks -->
            <div class="benchmark-marker national" *ngIf="showBenchmarks && measure.benchmark?.national !== undefined && measure.benchmark?.national!==0" [title]="(measure.benchmark?.national??0) * 100" [style.left.%]="(measure.benchmark?.national ?? 0) * 100" ></div>
            <div class="benchmark-marker registry" *ngIf="showBenchmarks && measure.benchmark?.registry !== undefined" [title]="(measure.benchmark?.registry??0) * 100" [style.left.%]="(measure.benchmark?.registry ?? 0) * 100"></div>
          </div>
        </div>
        
        <ng-container *ngIf="(showMeasureDetails || showPatientDetails) && selectedIndex === i">
          <!-- Measure Details Header -->
        <div class="details-header unselectable">
          <mat-tab-group mat-align-tabs="start" (selectedTabChange)="selectDetailsTab($event.tab.textLabel.toLowerCase())">
            <mat-tab label="MIPS Points Data" [class.active]="selectedDetailsTab === 'mipsData'" >



            </mat-tab>
            <mat-tab label="Patient Measures" [class.active]="selectedDetailsTab === 'patientMeasures'" ></mat-tab>
            <mat-tab label="Monthly Trends" [class.active]="selectedDetailsTab === 'monthlyTrends'" >
<app-measure-monthly-trend></app-measure-monthly-trend>

            </mat-tab>
          </mat-tab-group>
          <div class="header-actions">
           <!-- <button mat-button color="primary" class="goto-mips" (click)="onGoToMips()">
              <mat-icon>open_in_new</mat-icon> GO TO MIPS MVP
            </button>
          -->
            <button mat-icon-button class="export-details" (click)="onExportDetails()">
              <mat-icon>file_download</mat-icon>
            </button>
            <button mat-icon-button class="close-details" (click)="closeDetails()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

            <!-- Measure Details inserted after the clicked row -->
            <app-measure-details
              *ngIf="selectedDetailsTab == 'performanceData' && selectedIndex === i"
              [measure]="selectedMeasure"
              [isSmallPractice]="isSmallPractice"
              (close)="closeDetails()">
              <div class="details-actions">
                <button mat-raised-button color="primary" (click)="onViewPatients(selectedMeasure.id)">
                  <mat-icon>people</mat-icon> View Patients
                </button>
              </div>
            </app-measure-details>
          <!-- Patient Measures Details Component -->
      <app-patient-measure-details
      *ngIf="selectedDetailsTab == 'patientData' && selectedIndex === i"
      [measureId]="selectedMeasure.id"
      [patientMeasures]="getMeasurePatients()"
      (close)="closePatientDetails()">
      </app-patient-measure-details>


  </ng-container>
      </ng-container>
    </div>

  
  </div>

<!-- Legend Section -->
<div class="legend-section">
  <div class="legend-container">
    <!-- Measure Indicators -->
    <div class="legend-group">
      <h4 class="legend-group-title">Dashboard Legend</h4>
      <div class="legend-items-grid">
        <div class="legend-item-large">
          <span class="mips-indicator">M</span>
          <div class="legend-item-text">
            <span class="legend-item-label">MIPS Measure</span>
            <span class="legend-item-description">Included in Merit-based Incentive Payment System</span>
          </div>
        </div>
        
        <div class="legend-item-large">
          <span class="inverse-indicator">↓</span>
          <div class="legend-item-text">
            <span class="legend-item-label">Inverse Measure</span>
            <span class="legend-item-description">Lower values indicate better performance</span>
          </div>
        </div>
        
        <div class="legend-item-large">
          <span class="small-sample-indicator">*</span>
          <div class="legend-item-text">
            <span class="legend-item-label">Small Sample</span>
            <span class="legend-item-description">Denominator less than 20 patients</span>
          </div>
        </div>
      </div>
    </div>
    

    
   
  </div>
</div>
</div>
